import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CreateAgent from './components/CreateAgent';
import MessageWindow from './components/MessageWindow';
import PrivateRoute from './components/PrivateRoute';
import AIAssistantManagement from './components/AIAssistantManagement';
import AIAssistant from './components/AIAssistant';
import UserParameter from './components/UserParameter';
import Archive from './components/Archive';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import TagList from './components/TagList';
import PrivacyPolicy from './components/PrivacyPolicy.js';
import Payment from './components/Payment';
import InstagramAccountSelection from './components/InstagramAccountSelection';
import CreateForm from './components/CreateForm';
import FormResult from './components/FormResult';
import KnowledgeBoard from './components/KnowledgeBoard';
import Welcome from './components/Welcome';
import Chatbot from './components/ChatbotSettings';
import Statistics from './components/Statistics';
import Layout from './components/Layout';
import Billing from './components/ShopifyBillingTest';
import ShopifyCallback from './components/ShopifyCallback';
import ChatbotSettingsPage from './components/ChatbotSettingsPage.js'; // La nouvelle page
import ChatbotTest from './components/ChatbotTest';
import Brands from './components/brands';
import NotificationsSettings from './components/NotificationsSettings.js';
import ShopifySettings from './components/ShopifySettings.js';
import TrackingSettings from './components/TrackingSettings.js';
import FollowUpSettings from './components/FollowUpSettings.js';
import ParcelMonitor from './components/ParcelMonitor.js';
import StatusInstructions from './components/StatusInstructions.js';
import Carriers from './components/Carriers.js';
import CarrierDetail from './components/CarrierDetail.js';
import DataSources from './components/DataSources.js';
import Onboarding from './components/onboarding/Onboarding';
import TicketViewsParameters from './components/TicketViewsParameters.js';
import TicketFormSettings from './components/TicketFormSettings.js';

//import AppInitializer from './components/AppInitializer';
import LanguageSwitcher from './components/LanguageSwitcher';
import OrderDetails from './components/OrderDetails';
import CustomerList from './components/CustomerList.js';
import CustomerDetails from './components/CustomerDetails.js';
import ProductsList from './components/ProductsList.js';
import ProductDetails from './components/ProductDetails.js';
import OrdersList from './components/OrdersList.js';
import ShopStatistics from './components/ShopStatistics.js';
import ManageReturns from './components/ManageReturns.js';
import ReturnDetails from './components/ReturnDetails.js';
import Tickets from './components/Tickets.js';
import DownloadFile from "./components/DownloadFile.js"
import CreateProduct from './components/CreateProduct.js';
import ShopifyRegister from './components/ShopifyRegister.js';
import LogisticsSignup from './components/LogisticsSignup.js';
import ColissimoParams from './components/ColissimoParams.js';
import ColissimoLabels from './components/ColissimoLabels.js';
import Clients from './components/Clients';
import ClientDetails from './components/ClientDetails';
import ClientsInstructions from './components/ClientsInstructions';
import ClientEDNDetail from './components/ClientEDNDetail';
import WarehousesInstructions from './components/WarehousesInstructions';
import WarehouseDetail from './components/WarehouseDetail';
import OpenAPISchemeManagement from './components/OpenAPISchemeManagement';
import AIAutomation from './components/AIAutomation';
import RouterAgent from './components/RouterAgent';
import Refunds from './components/Refunds';
import CommerceOrders from './components/commerce/CommerceOrders';
import CustomerSms from './components/customerSms/CustomerSms';
import ShopConnections from './components/shops/ShopConnections';
import RefundDetail from './components/RefundDetail';
import VoiceTickets from './components/VoiceTickets';
import VoiceAgents from './components/voiceSetup/VoiceAgents';
import VoiceAgentPage from './components/voiceSetup/VoiceAgentPage';
import VoiceNumbers from './components/voiceSetup/VoiceNumbers';
import VoiceTicketDetail from './components/VoiceTicketDetail';
import Doctors from './components/Doctors';
import DoctorSchedules from './components/DoctorSchedules';
import Patients from './components/Patients';
import HospitalSettings from './components/HospitalSettings';

// Catalogue produits (allow-listed tenants): its own chunk, loaded on first visit.
const CatalogueProducts = lazy(() => import('./components/catalogue/CatalogueProducts.js'));
const CatalogueProduct = lazy(() => import('./components/catalogue/CatalogueProduct.js'));
const CatalogueConnections = lazy(() => import('./components/catalogue/CatalogueConnections.js'));
const CatalogueSettings = lazy(() => import('./components/catalogue/CatalogueSettings.js'));
const lazyPage = (Page) => <Suspense fallback={null}><Page /></Suspense>;


const LoginPage = () => (
  <div className="login-page-container">
    <LanguageSwitcher />
    <Login />
  </div>
);

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/shopify/callback" element={<ShopifyCallback />} />
        <Route path="/download/:filename" element={<DownloadFile />} />
        <Route path="/shopify-register" element={<ShopifyRegister />} />
        <Route path="/signup" element={<LogisticsSignup />} />


        <Route
          path="/*"
          element={
            <PrivateRoute
              component={({ isAuthenticated, userRole }) => (
                <Layout userRole={userRole} />
              )}
            />
          }
        >
          <Route path="dashboard" element={<Dashboard />} roles={['admin', 'employee']} />
          <Route path="voice-tickets" element={<VoiceTickets />} roles={['admin', 'logistics']} />
          {/* Agents vocaux: their own section, separate from the text agents (2026-10-07). */}
          <Route path="voice-agents" element={<VoiceAgents />} roles={['admin']} />
          <Route path="voice-agents/:agentId" element={<VoiceAgentPage />} roles={['admin']} />
          <Route path="voice-numbers" element={<VoiceNumbers />} roles={['admin']} />
          <Route path="voice-tickets/:callId" element={<VoiceTicketDetail />} roles={['admin', 'logistics']} />
          <Route path="doctors" element={<Doctors />} roles={['admin']} />
          <Route path="doctor-schedules" element={<DoctorSchedules />} roles={['admin']} />
          <Route path="patients" element={<Patients />} roles={['admin']} />
          <Route path="hospital-settings" element={<HospitalSettings />} roles={['admin']} />
          <Route path="parameters" element={<UserParameter />} roles={['admin','logistics']} />
          <Route path="create-agent" element={<CreateAgent />} roles={['admin']} />
          <Route path="tickets/:ticketId/messages" element={<MessageWindow />} roles={['admin', 'employee','logistics']} />
          <Route path="ai-assistants" element={<AIAssistantManagement />} roles={['admin']} />
          <Route path="my-ai-assistants" element={<AIAssistant />} roles={['admin']} />
          <Route path="statistics" element={<Statistics />} roles={['admin']} />
          {/* Productivity now lives in a tab of the Employees page */}
          <Route path="employee-productivity" element={<Navigate to="/create-agent" replace />} />
          <Route path="refunds" element={<Refunds />} roles={['admin', 'employee', 'logistics', 'logistician']} />
          <Route path="refunds/:refundId" element={<RefundDetail />} roles={['admin', 'employee', 'logistics', 'logistician']} />
          <Route path="commerce/orders" element={<CommerceOrders />} roles={['admin', 'employee', 'logistics', 'logistician']} />
          <Route path="shops" element={<ShopConnections />} roles={['admin', 'employee', 'logistics', 'logistician']} />
          <Route path="shop-statistics" element={<ShopStatistics />} roles={['admin']} />
          <Route path="billing" element={<Billing />} roles={['admin']} />
          <Route path="billing-success" element={<Billing />} roles={['admin']} />
          <Route path="billing-failed" element={<Billing />} roles={['admin']} />
          <Route path="chatbot" element={<Chatbot />} roles={['admin']} />
          <Route path="order/:orderId" element={<OrderDetails />} roles={['admin']}/>
          <Route path="form" element={<CreateForm />} roles={['admin']} />
          <Route path="knowledge-board" element={<KnowledgeBoard />} roles={['admin']} />
          <Route path="form-result/:form_id" element={<FormResult />} roles={['admin','logistics']} />
          <Route path="payment" element={<Payment />} roles={['admin']} />
          <Route path="returns" element={<ManageReturns />} roles={['admin']} />
          <Route path="return/:returnId" element={<ReturnDetails />} roles={['admin']} />
          <Route path="tickets/archive" element={<Archive />} roles={['admin','logistics']} />
          <Route path="tickets" element={<Tickets />} roles={['admin','logistics']} />
          <Route path="tags" element={<TagList />} roles={['admin']} />
          <Route path="chatbot-settings" element={<ChatbotSettingsPage />} roles={['admin', 'logistics']} />
          <Route path="ticket-form-settings" element={<TicketFormSettings />} roles={['admin', 'logistics']} />
          <Route path="instagram/account-selection" element={<InstagramAccountSelection />} roles={['admin']} />
          <Route path="orders" element={<OrdersList />} roles={['admin', 'logistics']} />
          <Route path="product/:productId" element={<ProductDetails />} roles={['admin', 'logistics']} />
          <Route path="brands" element={<Brands />} roles={['admin']} />
          <Route path="notifications-settings" element={<NotificationsSettings />} roles={['admin']} />
          <Route path="shopify-settings" element={<ShopifySettings />} roles={['eshop']} />
          <Route path="tracking-settings" element={<TrackingSettings />} roles={['admin']} />
          <Route path="followup-settings" element={<FollowUpSettings />} roles={['admin', 'logistics']} />
          <Route path="parcel-monitor" element={<ParcelMonitor />} roles={['admin', 'logistics']} />
          <Route path="sms-notifications" element={<CustomerSms />} roles={['admin', 'logistics']} />
          <Route path="status-instructions" element={<StatusInstructions />} roles={['admin', 'logistics']} />
          <Route path="carriers-instructions" element={<Carriers />} roles={['admin']} />
          <Route path="carriers-instructions/:carrierId" element={<CarrierDetail />} roles={['admin', 'logistics']} />
          <Route path="connectors" element={<DataSources />} roles={['admin', 'logistics']} />
          <Route path="onboarding" element={<Onboarding />} roles={['admin']} />
          <Route path="catalogue" element={lazyPage(CatalogueProducts)} roles={['admin', 'employee']} />
          <Route path="catalogue/products/:productId" element={lazyPage(CatalogueProduct)} roles={['admin', 'employee']} />
          <Route path="catalogue/connections" element={lazyPage(CatalogueConnections)} roles={['admin', 'employee']} />
          <Route path="catalogue/settings" element={lazyPage(CatalogueSettings)} roles={['admin', 'employee']} />
          <Route path="catalogue/assistant" element={<Navigate to="/catalogue?assistant=1" replace />} />
          <Route path="warehouses-instructions" element={<WarehousesInstructions />} roles={['admin']} />
          <Route path="warehouses-instructions/:warehouseId" element={<WarehouseDetail />} roles={['admin']} />
          <Route path="openapi-schemes" element={<OpenAPISchemeManagement />} roles={['admin']} />
          <Route path="ai-automation" element={<AIAutomation />} roles={['admin']} />
          <Route path="router-agent" element={<RouterAgent />} roles={['admin']} />
          <Route path="ticket-views-parameters" element={<TicketViewsParameters />} roles={['admin']} />
          <Route
            path="customers"
            element={<CustomerList />}
            roles={['admin', 'logistics']}
          />
          <Route
            path="products"
            element={<ProductsList />}
            roles={['admin', 'logistics']}
          />
          <Route
            path="customers/:customerId"
            element={<CustomerDetails />}
            roles={['admin', 'logistics']}
          />
          <Route path="products/create" element={<CreateProduct />} roles={['admin']} />
          <Route path="chatbot-test" element={<ChatbotTest />} roles={['admin']} />
          <Route path="colissimo-params" element={<ColissimoParams />} roles={['admin']} />
          <Route path="colissimo-labels" element={<ColissimoLabels />} roles={['admin']} />
          <Route path="clients" element={<Clients />} roles={['admin', 'employee']} />
          <Route path="clients/:clientId" element={<ClientDetails />} roles={['admin', 'employee']} />
          <Route path="clients-instructions" element={<ClientsInstructions />} roles={['admin']} />
          <Route path="clients-instructions/:clientId" element={<ClientEDNDetail />} roles={['admin', 'logistics']} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;